import queryString from 'query-string';

const useQueryString = () => {
  const isSSR = typeof window === 'undefined';

  if (isSSR) {
    return {};
  }
  return queryString.parse(window.location.search, { decode: false });
};

export default useQueryString;
